import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["termsCheckbox", "nextButton"]

  connect() {
    this.validateForm()
  }

  validateForm() {
    const isTermsAccepted = this.hasTermsCheckboxTarget ? this.termsCheckboxTarget.checked : true

    if (isTermsAccepted) {
      this.nextButtonTarget.disabled = false
      this.nextButtonTarget.classList.remove("bg-gray-100", "text-gray-400")
      this.nextButtonTarget.classList.add("bg-teal-800", "text-white")
    } else {
      this.nextButtonTarget.disabled = true
      this.nextButtonTarget.classList.add("bg-gray-100", "text-gray-400")
      this.nextButtonTarget.classList.remove("bg-teal-800", "text-white")
    }
  }
}